<div class="modal-container">
  <div class="modal-dialog modal-confirm">
    <div class="modal-content">
      <div
        type="button"
        class="close"
        data-dismiss="modal"
        (click)="activeModal.close('close')"
      >
        <i (click)="activeModal.close('close')" class="fa fa-times"></i>
      </div>
      <div class="modal-body text-center">
        <div class="modal-header justify-content-center">
          <div class="icon-box">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <h4 class="modal-title">Ups, algo salió mal</h4>
        <p>{{ content }}</p>
      </div>
    </div>
  </div>
</div>
